/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GiftconProductDetailDto } from '../models/GiftconProductDetailDto';
import type { PaginatedGiftconProductListDto } from '../models/PaginatedGiftconProductListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GiftconProductsService {
  /**
   * 기프티콘 상품 목록 조회
   * @returns PaginatedGiftconProductListDto
   * @throws ApiError
   */
  public static giftconProductControllerFindAllWithPaginationByBrandCode({
    page = 1,
    itemsPerPage = 30,
    brandCode,
    goodsCategoryName,
    keyword,
  }: {
    page?: number;
    itemsPerPage?: number;
    /**
     * 브랜드코드
     */
    brandCode?: string;
    /**
     * 카테고리(상품유형명) — 카테고리 목록 조회 API가 주는 값을 그대로 쓴다
     */
    goodsCategoryName?: string;
    /**
     * 검색어 — 상품명 또는 브랜드명에 포함된 상품을 찾는다(대소문자 무시)
     */
    keyword?: string;
  }): CancelablePromise<PaginatedGiftconProductListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcon-products',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
        brandCode: brandCode,
        goodsCategoryName: goodsCategoryName,
        keyword: keyword,
      },
    });
  }

  /**
   * 기프티콘 상품 카테고리 목록 조회 (상품 많은 순)
   * @returns string
   * @throws ApiError
   */
  public static giftconProductControllerFindCategories(): CancelablePromise<
    Array<string>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcon-products/categories',
    });
  }

  /**
   * 기프티콘 상품 상세 조회
   * @returns GiftconProductDetailDto
   * @throws ApiError
   */
  public static giftconProductControllerFindOneById({
    giftconProductId,
  }: {
    giftconProductId: number;
  }): CancelablePromise<GiftconProductDetailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/giftcon-products/{giftconProductId}',
      path: {
        giftconProductId: giftconProductId,
      },
    });
  }
}
